import React from 'react';
import { motion } from 'framer-motion';
import { FiClock, FiZap, FiArrowRight } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { useSubscription } from '@/contexts/SubscriptionContext';
import { getTrialDaysRemaining, isInActiveTrial } from '@/services/featureFlagsService';

const TrialBanner = () => {
  const navigate = useNavigate();
  const { profile } = useSubscription();
  
  // Check if user is in active trial
  const inTrial = isInActiveTrial(profile);
  const daysRemaining = getTrialDaysRemaining(profile);
  
  // Don't show if not in trial or trial expired
  if (!inTrial || daysRemaining === null || daysRemaining <= 0) {
    return null;
  }
  
  const isUrgent = daysRemaining <= 7;
  
  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      className={`w-full px-4 py-3 rounded-lg mb-4 flex items-center justify-between ${
        isUrgent 
          ? 'bg-gradient-to-r from-amber-500/20 to-orange-500/20 border border-amber-500/30' 
          : 'bg-gradient-to-r from-purple-500/20 to-cyan-500/20 border border-purple-500/30'
      }`}
    >
      <div className="flex items-center gap-3">
        <div className={`p-2 rounded-full ${
          isUrgent ? 'bg-amber-500/20' : 'bg-purple-500/20'
        }`}>
          {isUrgent ? (
            <FiClock className={`w-5 h-5 ${isUrgent ? 'text-amber-400' : 'text-purple-400'}`} />
          ) : (
            <FiZap className="w-5 h-5 text-cyan-400" />
          )}
        </div>
        
        <div>
          <p className="text-sm font-medium text-foreground">
            Free Trial: <span className={isUrgent ? 'text-amber-400' : 'text-cyan-400'}>
              {daysRemaining} day{daysRemaining !== 1 ? 's' : ''} remaining
            </span>
          </p>
          <p className="text-xs text-muted-foreground">
            Full Pro Trader access • Unlimited AI analyses
          </p>
        </div>
      </div>
      
      <motion.button
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
        onClick={() => navigate('/choose-plan')}
        className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-all border ${
          isUrgent 
            ? 'bg-amber-500/10 border-amber-500/50 text-amber-400 hover:bg-amber-500/20' 
            : 'bg-purple-500/10 border-purple-500/50 text-cyan-400 hover:bg-purple-500/20'
        }`}
      >
        Upgrade Now
        <FiArrowRight className="w-4 h-4" />
      </motion.button>
    </motion.div>
  );
};

export default TrialBanner;
